import { useMediaQuery } from 'react-responsive';

export const useBreakpoint = () => {
  // these breakpoints are based on the edrolo-ui breakpoints
  // any updates to either need to be manually kept in sync with edrolo-ui/variables/breakpoints.scss
  const smallOnly: boolean = useMediaQuery({ query: '(max-width: 768px)' });
  const mediumUp: boolean = useMediaQuery({ query: '(min-width: 769px)' });
  const largeUp: boolean = useMediaQuery({ query: '(min-width: 1200px)' });
  const xLargeUp: boolean = useMediaQuery({ query: '(min-width: 1600px)' });

  return {
    smallOnly,
    mediumUp,
    largeUp,
    xLargeUp,
  };
};
